const accessMaster = {

    COURSE_LIST: { name: 'Course', path: '/course-list' },
    ADD_COURSE: { name: 'Add Course', path: '/create-course' },
    UPDATE_COURSE: { name: 'Update Course', path: '/edit-course' },
    DELETE_COURSE: { name: 'Delete Course', path: '/delete-course' },

    COUNTRY_LIST: { name: 'Country', path: '/country-list' },
    ADD_COUNTRY: { name: 'Add Country', path: '/create-country' },
    UPDATE_COUNTRY: { name: 'Update Country', path: '/edit-country' },
    DELETE_COUNTRY: { name: 'Delete Country', path: '/delete-country' },

    STATE_LIST: { name: 'State', path: '/state-list' },
    ADD_STATE: { name: 'Add State', path: '/create-state' },
    UPDATE_STATE: { name: 'Update State', path: '/edit-state' },
    DELETE_STATE: { name: 'Delete State', path: '/delete-state' },

    CITY_LIST: { name: 'City', path: '/city-list' },
    ADD_CITY: { name: 'Add City', path: '/create-city' },
    UPDATE_CITY: { name: 'Update City', path: '/edit-city' },
    DELETE_CITY: { name: 'Delete City', path: '/delete-city' },

    DISTRICT_LIST: { name: 'District', path: '/district-list' },
    ADD_DISTRICT: { name: 'Add District', path: '/create-district' },
    UPDATE_DISTRICT: { name: 'Update District', path: '/edit-district' },
    DELETE_DISTRICT: { name: 'Delete District', path: '/delete-district' },

    TEHSIL_LIST: { name: 'Tehsil', path: '/tehsil-list' },
    ADD_TEHSIL: { name: 'Add Tehsil', path: '/create-tehsil' },
    UPDATE_TEHSIL: { name: 'Update Tehsil', path: '/edit-tehsil' },
    DELETE_TEHSIL: { name: 'Delete Tehsil', path: '/delete-tehsil' },

    SESSION_LIST: { name: 'Session', path: '/session-list' },
    ADD_SESSION: { name: 'Add Session', path: '/create-session' },
    UPDATE_SESSION: { name: 'Update Session', path: '/edit-session' },
    DELETE_SESSION: { name: 'Delete Session', path: '/delete-session' },

    SEMESTER_LIST: { name: 'Semester', path: '/semester-list' },
    ADD_SEMESTER: { name: 'Add Semester', path: '/create-semester' },
    UPDATE_SEMESTER: { name: 'Update Semester', path: '/edit-semester' },
    DELETE_SEMESTER: { name: 'Delete Semester', path: '/delete-semester' },

    STUDENT_LIST: { name: 'Student', path: '/student-list' },
    ADD_STUDENT: { name: 'Add Student', path: '/create-student' },
    UPDATE_STUDENT: { name: 'Update Student', path: '/edit-student' },
    DELETE_STUDENT: { name: 'Delete Student', path: '/delete-student' },
    STUDENT_DETAILS: { name: 'Student Details', path: '/student-details' },

    SUBJECT_LIST: { name: 'Subject', path: '/subject-list' },
    ADD_SUBJECT: { name: 'Add Subject', path: '/create-subject' },
    UPDATE_SUBJECT: { name: 'Update Subject', path: '/edit-subject' },
    DELETE_SUBJECT: { name: 'Delete Subject', path: '/delete-subject' },

    DESIGNATION_LIST: { name: 'Designation', path: '/designation-list' },
    ADD_DESIGNATION: { name: 'Add Designation', path: '/create-designation' },
    UPDATE_DESIGNATION: { name: 'Update Designation', path: '/edit-designation' },
    DELETE_DESIGNATION: { name: 'Delete Designation', path: '/delete-designation' },

    DEPARTMENT_LIST: { name: 'Department', path: '/department-list' },
    ADD_DEPARTMENT: { name: 'Add Department', path: '/create-department' },
    UPDATE_DEPARTMENT: { name: 'Update Department', path: '/edit-department' },
    DELETE_DEPARTMENT: { name: 'Delete Department', path: '/delete-department' },

    SLOT_LIST: { name: 'Slot', path: '/slot-list' },
    ADD_SLOT: { name: 'Add Slot', path: '/create-slot' },
    UPDATE_SLOT: { name: 'Update Slot', path: '/edit-slot' },
    DELETE_SLOT: { name: 'Delete Slot', path: '/delete-slot' },

    PAYMENT_MASTER_LIST: { name: 'Payment', path: '/payment-list' },
    ADD_PAYMENT_MASTER: { name: 'Add Payment', path: '/create-payment' },
    UPDATE_PAYMENT_MASTER: { name: 'Update Payment', path: '/edit-payment' },
    DELETE_PAYMENT_MASTER: { name: 'Delete Payment', path: '/delete-payment' },

    COUPON_LIST: { name: 'Coupon', path: '/coupon-list' },
    ADD_COUPON: { name: 'Add Coupon', path: '/create-coupon' },
    UPDATE_COUPON: { name: 'Update Coupon', path: '/edit-coupon' },
    DELETE_COUPON: { name: 'Delete Coupon', path: '/delete-coupon' },
    COUPON_DETAILS: { name: 'Coupon Details', path: '/coupon-details' },

    STAFF_LIST: { name: 'Staff', path: '/staff-list' },
    ADD_STAFF: { name: 'Add Staff', path: '/create-staff' },
    UPDATE_STAFF: { name: 'Update Staff', path: '/edit-staff' },
    DELETE_STAFF: { name: 'Delete Staff', path: '/delete-staff' },

}

export default accessMaster;